/**
 * ICONSConfig : ICONSConfig
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */
const ICONSConfig = (function() {
    const common = {
        css: {
            width: '15px',
            height: '15px',
            cursor: 'pointer'
        },
        nbsp: 2
    };
    const icons = {
        src: ['undo.svg', 'add.svg', 'edit.svg', 'copy.svg', 'delete.svg', "full_screen.svg", 'correct_symbol.svg', 'update.svg', 'close.svg']
    };

    const init = _default_config => {
        for (let i = 0; i < icons.src.length; ++i) {
            const key = icons.src[i].split('.')[0];
            icons[key] = {};
            Object.assign(icons[key], common);
            icons[key]['src'] = _default_config.api_urls.img_src + icons.src[i];
            icons[key + 'IconHTML'] = config => initScript.bindAttrsOnHTMLTag('img', '', Object.assign(config, icons[key]));
        }
        return icons;
    };
    
    return {
        init
    };
})();
